import { connect } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
import { editDeviation } from '../../redux/deviations/actionCreators';
const mapStateToProps = (state, { tier  })=>{
    return {
        isOwner: getIsCurrentUserAuthorOf(state, tier)
    };
};
const mapDispatchToProps = (dispatch, { tier: deviation  })=>({
        onClick: ()=>dispatch(editDeviation({
                deviation
            }))
    });
export default connect(mapStateToProps, mapDispatchToProps);
